// extracted by mini-css-extract-plugin
export default {"upload":"index_upload__0L98Y","hideUploadArea":"index_hideUploadArea__4RtYF","uploadOuter":"index_uploadOuter__ta+c0","rounded":"index_rounded__G1sqU"};